import React from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

export default ({text = ''}) => (
    <span style={{
        position:"relative",
        display:'inline-block',
    }}>
         <div className="tooltip-field" data-scroll-hide={true}  data-tip='' data-tooltip-id='tooltip-title_ar'
              data-iscapture="false" data-place="top" data-effect="solid" data-multiline="true">

            <span style={{
                margin:"0 5px",
                background:"#18a0a4",
                color: "#fff",
                padding: 5,
                width: 20,
                height: 20,
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 5,
                display: 'flex',
                cursor:"pointer"
            }}>
                ?
            </span>

             <ReactTooltip
                 id='tooltip-title_ar'>{text}</ReactTooltip>
                                </div>
    </span>
);